import { BreadcrumbData } from '@ardoq/basic-components';
import { type I18nLocale, t } from '@ardoq/i18n';
import { FieldAnswerValue, AttributeAnswerValue } from '../types';
import { SelectOption } from '@ardoq/select';

export const breadcrumbsToNamePath = (breadcrumbs: BreadcrumbData[]) => {
  return breadcrumbs.map(breadcrumb => breadcrumb.text);
};

export const namePathToString = (namePath: string[]) => {
  return namePath.join(' > ');
};

export const isValueEmpty = (
  value: FieldAnswerValue | AttributeAnswerValue | SelectOption<string>
) => value === undefined || value === null;

export const isValueStringOrEmpty = (
  value: FieldAnswerValue | AttributeAnswerValue
) => typeof value === 'string' || isValueEmpty(value);

export const isValueBooleanOrEmpty = (
  value: FieldAnswerValue | AttributeAnswerValue
) => typeof value === 'boolean' || isValueEmpty(value);

const getReadableConditionAnswer = (
  conditionAnswer: unknown,
  i18nLocale: I18nLocale
) => {
  switch (conditionAnswer) {
    case undefined:
    case null:
      return t(i18nLocale, 'surveysUi:conditionAnswer.unset', 'Unset');
    case true:
      return t(i18nLocale, 'surveysUi:conditionAnswer.checked', 'Checked');
    case false:
      return t(i18nLocale, 'surveysUi:conditionAnswer.unchecked', 'Unchecked');
    default:
      return conditionAnswer;
  }
};

export const getConditionAnswerTitle = (
  conditionAnswer: unknown,
  conditionQuestionName: string,
  i18nLocale: I18nLocale
) => {
  return `${conditionQuestionName} - ${getReadableConditionAnswer(conditionAnswer, i18nLocale)}`;
};
